<div class="spinner-wrapper">
    <div class="spinner-ring-wrapper">
        <svg class="spinner-ring" viewBox="0 0 48 48">
            <circle class="spinner-ring-track" cx="24" cy="24" r="20"></circle>
            <circle class="spinner-ring-arc" cx="24" cy="24" r="20"></circle>
        </svg>
        <mat-icon #spinnerIcon [svgIcon]="iconRef" class="spinner-icon"></mat-icon>
    </div>
    <span *ngIf="message" class="spinner-message">{{message}}</span>
</div>